var _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _circle, _circle2, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _circle3, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _polygon1, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _polygon18, _path72, _polygon19, _polygon20, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 436.88 284.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Objects"
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.01,
    y1: 248.92,
    x2: 424.05,
    y2: 248.92,
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M341.16,164.16c-20.23,0-36.64,12.5-36.64,27.91,0,7.87,4.28,15,11.16,20.05l-8.17,13.73,18.74-8.28A46.37,46.37,0,0,0,341.16,220c20.24,0,36.64-12.5,36.64-27.92S361.4,164.16,341.16,164.16Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#1b75bc"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(272.93 95.46)",
    fontSize: 17,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "Python"), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.19,241.86H338.51a.6.6,0,0,0-.6.6V248H327l11,9.7v26a.61.61,0,0,0,.6.61h43.68a.6.6,0,0,0,.6-.61V242.46A.6.6,0,0,0,382.19,241.86Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#262262"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(302.86 168.12)",
    fontSize: 20.36,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "PHP"), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M344.85,100.21H262.13a.83.83,0,0,0-.82.83v40.83a.82.82,0,0,0,.82.82h12.58l1,11.59L285,142.69h59.82a.83.83,0,0,0,.83-.82V101A.83.83,0,0,0,344.85,100.21Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#df4438"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(241.53 27.03)",
    fontSize: 20.36,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "HTML"), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M222.24,107.42H139.52a.83.83,0,0,0-.82.83v40.83a.82.82,0,0,0,.82.82h59.83l9.27,11.59,1-11.59h12.58a.83.83,0,0,0,.83-.82V108.25A.83.83,0,0,0,222.24,107.42Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#8dc63f"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(123.12 32.28)",
    fontSize: 20.36,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "&lt;/&gt;"), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.19,174.72H123.51a.6.6,0,0,0-.6.6V216.6a.6.6,0,0,0,.6.6h20.56l9.28,11.58,1-11.58h12.81a.6.6,0,0,0,.6-.6V175.32A.6.6,0,0,0,167.19,174.72Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#fbb040"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(94.17 104.58)",
    fontSize: 27.33,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "J"), /*#__PURE__*/React.createElement("text", {
    transform: "translate(110.56 100.02)",
    fontSize: 13.66,
    fill: "#fff",
    fontFamily: "CourierNewPS-BoldMT, Courier New",
    fontWeight: 700,
    style: {
      isolation: "isolate"
    }
  }, "S")), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.63,218.43c-3.11,3.88-7.92,6.93-8.71,11.85-.61,3.79,1.44,7.48,3.8,10.51s5.16,5.85,6.45,9.47.91,7.66.89,11.54.48,8.07,3.11,10.92c2.39,2.6,6,3.54,9.5,4.24a153.19,153.19,0,0,0,21.12,2.78c6.71.41,14.45-.08,18.57-5.38,5.55-7.15,1.07-18.54,6.21-26a53.81,53.81,0,0,1,4.24-4.71c3.93-4.43,5.83-10.92,3.86-16.5-1.51-4.26-5-7.52-7.07-11.51-2.42-4.6-2.94-10-2.83-15.16a21.28,21.28,0,0,0-.41-6.33,15.33,15.33,0,0,0-3.84-6A38.11,38.11,0,0,0,254,177.24a27.46,27.46,0,0,0-20.29,2.09,37.55,37.55,0,0,0-8.5,6.9c-4.54,4.65-6.41,9.14-5.07,15.5C221.4,207.64,220.51,213.59,216.63,218.43Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M227.6,201.3c-.41,5.36-1.56,11-5.12,15-1.89,2.13-4.38,3.7-6.14,5.94a12.69,12.69,0,0,0-2.21,11.09c1.31,4.63,5.13,8.1,7.17,12.45,1.6,3.42,2,7.25,2.43,11,2.07-1.11,3-3.69,2.8-6a19,19,0,0,0-2.23-6.63,16.85,16.85,0,0,1-2.07-6.67c-.09-3.21,1.59-6.2,3.48-8.8s4.08-5.06,5.28-8c1.95-4.83,1-10.28.09-15.41,2.85,7.24,5.74,15.13,3.62,22.61-1,3.45-3,6.6-3.49,10.15a16.83,16.83,0,0,0,2.62,10.89,50,50,0,0,0,7.29,8.76,195,195,0,0,1,1.63-20.92,9.49,9.49,0,0,1,1.38-4.24,13.63,13.63,0,0,1,3.05-2.65,22.63,22.63,0,0,0,7.57-11.52,40.3,40.3,0,0,0,1.3-13.88c.43,5.18,3.33,10.17,2.45,15.29-.41,2.42-1.65,4.62-2.26,7a5.31,5.31,0,0,0-.16,2.34,7,7,0,0,0,1.53,2.71,22,22,0,0,1,4.35,9.41c1,5.67-1.09,11.36-3.11,16.75,1.9-.4,3.33-1.93,4.61-3.38a20.82,20.82,0,0,0,4.46-6.55c1.62-4.58-.11-9.61-1.81-14.16s-3.38-9.62-1.66-14.17c1.32-3.46,4.49-6.19,4.88-9.87-1.23,1.61-.24,3.92.87,5.61,1.58,2.39,3.39,4.63,4.79,7.13a14.48,14.48,0,0,1,2.16,8.18c-.22,2.52-1.36,4.85-2.37,7.17-2.57,5.91-4.29,12.72-2,18.74.7-5.89,4.54-10.86,6.74-16.37,2-4.86,2.58-10.45.69-15.33-1.38-3.56-4-6.48-6.13-9.63s-4-6.86-3.42-10.64c.1-.74.11-1.77-.62-1.92",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#b74913",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M239.18,218.56s-1.28,25.9-2.91,33.31,7,10.85,13.93,10.87c4.94,0,12.8-2.58,11-10.18,0,0-5.37-25.67-5-34Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#eeb399"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M256.21,218.56h-17s-.28,5.62-.74,12.37c3.7,1.71,10,3.21,19,.87A82,82,0,0,1,256.21,218.56Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#d89e87"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M295.76,261.24c-2.6-7.32-9.17-9.57-20.63-11S257.6,243,257.6,243H239.93s-6.08,5.76-17.54,7.22-18,3.71-20.62,11,.91,21.09,9.32,33.78,5.65,40.51,5.65,40.51h64S278,307.71,286.43,295,298.35,268.56,295.76,261.24Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#eeb399"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M218.18,184.8s-1.32,40.21,28.06,43.33,31.37-33.66,31.37-43.33c0,0-1.34-23.08-29.72-23.28S218,179.08,218.18,184.8Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#eeb399"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M262.64,164.35a27.2,27.2,0,0,0-14.7.62,43.51,43.51,0,0,0-7.23,3.35c-5.33,3-10.51,6.4-14.37,11.11a60.35,60.35,0,0,0-5.49,8.52,33.56,33.56,0,0,0-2.3,4.37c.15,1.45.37,3,.66,4.73,2,1,6.32,0,8.09-.26a35.85,35.85,0,0,0,9.6-2.95c1.63-.76,7.83-3.45,8.23-5.37a16.06,16.06,0,0,1-3.65,7.28,18.09,18.09,0,0,0,13-10,25.43,25.43,0,0,1,.36,8.3,29.38,29.38,0,0,0,3.65-6.43,31.79,31.79,0,0,0,17.8,11.76,85,85,0,0,0,1.29-14.57A25.3,25.3,0,0,0,262.64,164.35Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#d89e87"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278,198.14a3.79,3.79,0,0,1,3.46,2.19,8.36,8.36,0,0,1,.68,4.23,11,11,0,0,1-.93,4.24,5.52,5.52,0,0,1-3.12,2.9,3.7,3.7,0,0,1-4-1C271.68,207.6,273.4,198.49,278,198.14Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#eeb399"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M276.64,210.16a.21.21,0,0,1-.2-.16,11.46,11.46,0,0,1,1.88-10.28.21.21,0,1,1,.32.28,11,11,0,0,0-1.79,9.89.22.22,0,0,1-.15.26Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M276.3,208.5a.21.21,0,0,1-.19-.11.21.21,0,0,1,.09-.28c3.28-1.81,1.15-6.69,1.13-6.74a.2.2,0,0,1,.11-.27.2.2,0,0,1,.27.1c0,.06,2.31,5.28-1.31,7.28Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.49,198.14a3.8,3.8,0,0,0-3.46,2.19,8.36,8.36,0,0,0-.68,4.23,10.79,10.79,0,0,0,.94,4.24,5.47,5.47,0,0,0,3.11,2.9,3.71,3.71,0,0,0,4-1C225.85,207.6,224.13,198.49,219.49,198.14Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#eeb399"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M220.88,210.16a.2.2,0,0,0,.2-.16,11.39,11.39,0,0,0-1.88-10.28.21.21,0,1,0-.31.28,11,11,0,0,1,1.79,9.89.21.21,0,0,0,.14.26Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M221.23,208.5a.21.21,0,0,0,.18-.11.2.2,0,0,0-.08-.28c-3.29-1.81-1.16-6.69-1.14-6.74a.2.2,0,0,0-.1-.27.21.21,0,0,0-.28.1c0,.06-2.31,5.28,1.32,7.28Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M225.21,200.37a28.12,28.12,0,0,1,.16,3.78,4,4,0,0,1-1.77,3.18,13.82,13.82,0,0,0-2.94-6.74,4.66,4.66,0,0,1-1.24-2.53l3-1.28c.59-.26,1.14-.6,1.72-.86.22-.09,1.59-.48,1.62-.54A11,11,0,0,0,225.21,200.37Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M270.9,200.37a28.12,28.12,0,0,0-.16,3.78,4,4,0,0,0,1.77,3.18,13.89,13.89,0,0,1,2.93-6.74,4.6,4.6,0,0,0,1.25-2.53l-3-1.28c-.59-.26-1.14-.6-1.73-.86-.21-.09-1.58-.48-1.61-.54A11,11,0,0,1,270.9,200.37Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M219.49,198.14s25.47-7.91,31.74-19.7c0,0-3.08,13.28-7.15,16.48,0,0,9.77-5.24,10.81-14.65,0,0,3.29,9.63,1.27,13.92,0,0,3.19-8.37,2.32-14.64,0,0,10,17,17.79,20.1,0,0,14.57-40-26.45-39.39S216.69,187.19,219.49,198.14Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M253.79,198.73a10.5,10.5,0,0,0,1.17,3.38,2.89,2.89,0,0,0,2.5,1.62,2.69,2.69,0,0,0,2.47-1.56,6.12,6.12,0,0,0,.62-1.63,11.9,11.9,0,0,0,.34-1.78v0a.28.28,0,0,1,.32-.24.28.28,0,0,1,.24.25,7.75,7.75,0,0,1-.51,3.93,4.12,4.12,0,0,1-1.35,1.71,3.7,3.7,0,0,1-2.15.63,3.64,3.64,0,0,1-2.12-.7,4.26,4.26,0,0,1-1.33-1.67,8.38,8.38,0,0,1-.77-3.88.29.29,0,0,1,.29-.27.27.27,0,0,1,.27.22Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M243.44,198.76a8.37,8.37,0,0,1-.76,3.88,4.35,4.35,0,0,1-1.33,1.67,3.67,3.67,0,0,1-2.13.7,3.75,3.75,0,0,1-2.15-.63,4,4,0,0,1-1.34-1.71,7.54,7.54,0,0,1-.51-3.93.27.27,0,0,1,.31-.25.27.27,0,0,1,.24.24v0a10.75,10.75,0,0,0,.34,1.78,6.12,6.12,0,0,0,.62,1.63,2.69,2.69,0,0,0,2.47,1.56,2.86,2.86,0,0,0,2.49-1.62,10.76,10.76,0,0,0,1.18-3.38v0a.29.29,0,0,1,.34-.22A.28.28,0,0,1,243.44,198.76Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M248.49,205.56a12,12,0,0,1,.51,2.24h0l-.48-.23a10.15,10.15,0,0,1,1.27-.76c.22-.1.44-.21.67-.3a2.44,2.44,0,0,1,.76-.22.68.68,0,0,1,.51.19.8.8,0,0,1,.21.42,2.1,2.1,0,0,1,0,.79,3.72,3.72,0,0,1-.54,1.4,10,10,0,0,1-1.88,2.21,5,5,0,0,1-2.51,1.38s-.06,0-.07-.05a.08.08,0,0,1,.05-.07,4.85,4.85,0,0,0,2.37-1.44,9.4,9.4,0,0,0,1.72-2.21,3.27,3.27,0,0,0,.44-1.27c0-.41-.07-1-.3-.87a2.35,2.35,0,0,0-.59.21l-.63.31a9.94,9.94,0,0,0-1.15.76l0,0a.3.3,0,0,1-.4,0,.35.35,0,0,1-.06-.19h0a12.79,12.79,0,0,0-.07-2.23.09.09,0,0,1,.07-.1A.08.08,0,0,1,248.49,205.56Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M236.17,213.54a19.06,19.06,0,0,0,4,3,16.1,16.1,0,0,0,4.56,1.79,14.36,14.36,0,0,0,2.43.34,15.54,15.54,0,0,0,2.46-.12,18.78,18.78,0,0,0,4.79-1.29h0a.06.06,0,0,1,0,0,24.84,24.84,0,0,1-2.3,1,13.93,13.93,0,0,1-2.46.65,12.73,12.73,0,0,1-5.07-.08,14.83,14.83,0,0,1-4.73-1.88,15.41,15.41,0,0,1-3.83-3.32.11.11,0,0,1,0-.16.11.11,0,0,1,.15,0Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#a5583d"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 200.53,
    cy: 100.86,
    r: 7.28,
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 257.86,
    cy: 201.08,
    r: 7.28,
    transform: "translate(-65.48 261.93) rotate(-67.46)",
    fill: "#fff",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200.53,
    cy: 100.86,
    r: 7.28,
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.57
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.86,
    cy: 201.08,
    r: 7.28,
    transform: "translate(-65.48 261.93) rotate(-67.46)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.57
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M246.58,201.75a3.81,3.81,0,0,1,4,0",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#231f20",
    strokeMiterlimit: 10,
    strokeWidth: 0.57
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M265.13,201.08s8.19.06,10.5-1.43",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M231.94,201.08s-9.77-1.07-12.45-2.94",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M258.93,188.91a3.65,3.65,0,0,0-1.77.79,1.22,1.22,0,0,0-.43,1.17c.28,1,2.94.74,3.72.87a13.63,13.63,0,0,1,4.22,1.31,1.5,1.5,0,0,0,.83.26,1,1,0,0,0,.65-1.26,2.45,2.45,0,0,0-1.08-1.17,13.42,13.42,0,0,0-3.76-1.7A6.4,6.4,0,0,0,258.93,188.91Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M239.67,189.91a3.5,3.5,0,0,1,1.76.8,1.17,1.17,0,0,1,.43,1.16c-.27,1-2.93.75-3.72.87a13.77,13.77,0,0,0-4.21,1.32,1.51,1.51,0,0,1-.84.26,1,1,0,0,1-.64-1.27,2.33,2.33,0,0,1,1.08-1.16,13.24,13.24,0,0,1,3.75-1.7A6.48,6.48,0,0,1,239.67,189.91Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M258.44,161.52s-46.24-5-38.25,35.6c0,0,31.86-15.74,39.24-33.57,0,0-.18,19,16.2,34.58C275.64,198.13,285.75,167.48,258.44,161.52Z",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#b74913",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M259.43,162.57s-36.78-.5-39.24,34.55c0,0,19.81-29.14,39.24-33.57,0,0,15.81,16.16,16.2,34.58C275.64,198.13,280.21,170.81,259.43,162.57Z",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#b74913",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.22,178.44c5.23-6,6.21-14.89,6.21-14.89s-2.54,9.41-2,16.8",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#b74913",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M258.53,161.23a32,32,0,0,0-8-1.5,48.83,48.83,0,0,0-8.2.14,55.28,55.28,0,0,0-8.06,1.51c-1.34.3-2.62.79-3.94,1.17s-2.56,1-3.85,1.44a.05.05,0,0,1,0-.1c1.28-.49,2.55-1,3.85-1.46s2.6-.89,3.94-1.2a55.39,55.39,0,0,1,8.08-1.55,49.18,49.18,0,0,1,8.23-.19,32.46,32.46,0,0,1,8.11,1.47.14.14,0,0,1,.09.18.13.13,0,0,1-.18.09h0Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M271.56,166.61a14.84,14.84,0,0,1,3.93,3.51,20.44,20.44,0,0,1,2.72,4.5,25.26,25.26,0,0,1,1.55,5c.19.86.27,1.74.4,2.6s.12,1.75.18,2.62a0,0,0,0,1,0,0,0,0,0,0,1,0,0c-.07-.87-.12-1.74-.2-2.61s-.23-1.73-.43-2.58a25,25,0,0,0-1.59-5,20.69,20.69,0,0,0-2.72-4.42,14.66,14.66,0,0,0-3.89-3.4h0a.13.13,0,0,1-.05-.19.15.15,0,0,1,.19-.06Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M220,214.08a87.63,87.63,0,0,1-6.55,6.38,28,28,0,0,0-3.38,3,9.91,9.91,0,0,0-2.25,3.91s0,0,0,0a0,0,0,0,1,0,0,10.11,10.11,0,0,1,2.22-4,29.72,29.72,0,0,1,3.35-3.1,83.52,83.52,0,0,0,6.46-6.44.14.14,0,0,1,.22.18Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M277.18,247.92c1.29-1,2.56-2.09,3.82-3.16s2.49-2.18,3.65-3.35a10.25,10.25,0,0,0,2.19-4.35,23,23,0,0,0,.75-4.88.05.05,0,1,1,.1,0,23.36,23.36,0,0,1-.71,4.92,10.47,10.47,0,0,1-2.19,4.44c-1.16,1.2-2.4,2.3-3.64,3.4s-2.51,2.16-3.79,3.2a.14.14,0,1,1-.18-.22Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#442614"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M265.1,207a.45.45,0,1,1-.45-.45A.45.45,0,0,1,265.1,207Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.3,205.79a.46.46,0,0,1-.46.45.45.45,0,0,1-.45-.45.46.46,0,0,1,.45-.46A.47.47,0,0,1,267.3,205.79Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M268.2,208.87a.45.45,0,0,1-.9,0,.45.45,0,1,1,.9,0Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M230.78,207a.45.45,0,0,0,.45.45.45.45,0,1,0,0-.9A.45.45,0,0,0,230.78,207Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 190.27,
    cy: 105.57,
    r: 0.45,
    fill: "#e53d2e"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M227.68,208.87a.45.45,0,0,0,.45.45.46.46,0,0,0,.46-.45.47.47,0,0,0-.46-.46A.46.46,0,0,0,227.68,208.87Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#e53d2e"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.77,261.24c-2.6,7.32.92,21.09,9.32,33.78s5.65,40.51,5.65,40.51h64S278,307.71,286.43,295s11.92-26.46,9.33-33.78c-2.39-6.73-8.15-9.17-18-10.66a77.32,77.32,0,0,1-23.4,7.31l-7.25,13-6-13.26c-8.69,1.19-18-3.5-23.14-6.73C209.23,252.38,204,254.92,201.77,261.24Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#008ac5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M241,348.1l-19.59-33.52,5.47-47.85a12.91,12.91,0,1,0-25.65-2.94l-6,51.95-.16,1.46a9.63,9.63,0,0,0,2.77,7.89l31.74,31.77A7.24,7.24,0,0,0,241,348.1Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#008ac5"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M217.66,299.45a.28.28,0,0,1-.26-.2l-1.64-6a49.31,49.31,0,0,1-2.21-11.8,24.79,24.79,0,0,1,3.44-13,.28.28,0,0,1,.37-.1.28.28,0,0,1,.09.37,24.24,24.24,0,0,0-3.37,12.73,48.6,48.6,0,0,0,2.19,11.67l1.64,6a.27.27,0,0,1-.18.33Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#772020"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M213.82,278.68a.26.26,0,0,1-.26-.21,43.3,43.3,0,0,1-.82-8.42.27.27,0,0,1,.27-.27h0a.27.27,0,0,1,.26.27,43,43,0,0,0,.81,8.31.26.26,0,0,1-.21.31Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#772020"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M217.66,299.45v11.4s2.85,2.27,8.07,11.21L234,336.18",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M217.66,310.85s-.62-2.81-9.07-1.42",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M206.12,311.83a14.09,14.09,0,0,1,10.12-1",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M226.85,310a165.33,165.33,0,0,1,43.83,6.36",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M239.08,314.09a95.58,95.58,0,0,0,17.65,4.25",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M256.59,348.1l19.59-33.52-5.47-47.85a12.91,12.91,0,1,1,25.65-2.94l5.95,51.95.16,1.46a9.63,9.63,0,0,1-2.77,7.89L268,356.86a7.24,7.24,0,0,1-11.37-8.76Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#008ac5"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M279.88,299.45a.28.28,0,0,0,.26-.2l1.64-6a49.31,49.31,0,0,0,2.21-11.8,24.79,24.79,0,0,0-3.44-13,.28.28,0,0,0-.37-.1.28.28,0,0,0-.09.37,24.24,24.24,0,0,1,3.37,12.73,48.6,48.6,0,0,1-2.19,11.67l-1.64,6a.27.27,0,0,0,.18.33Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#772020"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M283.72,278.68a.27.27,0,0,0,.26-.21,43.3,43.3,0,0,0,.82-8.42.27.27,0,0,0-.27-.27h0a.27.27,0,0,0-.26.27,43,43,0,0,1-.81,8.31.26.26,0,0,0,.21.31Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#772020"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M279.88,299.45v11.4s-2.85,2.27-8.07,11.21l-8.25,14.12",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M279.88,310.85s.62-2.81,9.07-1.42",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M291.42,311.83a14.11,14.11,0,0,0-10.13-1",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#772020",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "274.58 264.01 145.36 264.01 132.58 193.99 287.43 193.99 274.58 264.01",
    fill: "#d1d3d4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 261.81 89.02 255.59 66.98 253.68 47.28 259.87 69.61 261.81",
    fill: "#747477"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.96 153.07 130.63 231.66 15.04 212.35 0 138.23 118.96 153.07",
    fill: "#d1d3d4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.46 179.37 92.18 217.84 35.59 208.38 28.62 170.37 86.46 179.37",
    fill: "#b3babc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "47.28 192.32 47.28 259.87 69.61 261.81 69.61 194.82 47.28 192.32",
    fill: "#acaeaf"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "69.61 194.82 47.28 192.32 47.28 194.03 67.43 196.33 67.43 261.62 67.43 261.62 69.61 261.81 69.61 194.82",
    fill: "#909091"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "86.46 179.37 28.62 170.37 29.03 172.61 84.69 181.51 89.95 217.46 92.18 217.84 86.46 179.37",
    fill: "#909091"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "118.96 153.07 0 138.23 0.73 141.85 117.18 155.02 128.4 231.28 130.63 231.66 118.96 153.07",
    fill: "#909091"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "45.47 158.65 44.03 158.5 42.88 149.32 44.33 149.47 45.47 158.65",
    fill: "#909091"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    points: "48.3 158.93 46.86 158.78 45.72 149.61 47.16 149.75 48.3 158.93",
    fill: "#909091"
  })), _polygon1 || (_polygon1 = /*#__PURE__*/React.createElement("polygon", {
    points: "51.13 159.22 49.69 159.07 48.55 149.89 49.99 150.04 51.13 159.22",
    fill: "#909091"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "53.96 159.5 52.52 159.35 51.38 150.18 52.82 150.32 53.96 159.5",
    fill: "#909091"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "56.79 159.78 55.35 159.64 54.2 150.46 55.65 150.61 56.79 159.78",
    fill: "#909091"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "59.62 160.07 58.18 159.92 57.03 150.75 58.48 150.89 59.62 160.07",
    fill: "#909091"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "62.45 160.35 61.01 160.21 59.87 151.03 61.31 151.18 62.45 160.35",
    fill: "#909091"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.28 160.64 63.84 160.49 62.7 151.32 64.14 151.46 65.28 160.64",
    fill: "#909091"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "68.11 160.92 66.67 160.78 65.53 151.6 66.97 151.75 68.11 160.92",
    fill: "#909091"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "70.94 161.21 69.5 161.06 68.36 151.88 69.8 152.03 70.94 161.21",
    fill: "#909091"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "73.77 161.49 72.33 161.34 71.19 152.17 72.63 152.31 73.77 161.49",
    fill: "#909091"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M371.61,341.08a2.18,2.18,0,0,0-.67-.1h-4v-4.41a.94.94,0,0,0-.51-.83c-1.15-.58-4.5-1.76-12.78-1.76-8.45,0-11.77,1.23-12.85,1.79a.82.82,0,0,0-.44.72v31.08s3.58,2.23,12.48,2.23,14.1-2.23,14.1-2.23v-2.78h4.78a2.22,2.22,0,0,0,1.15-.32c.67-.4,4-2.86,4-11.88C376.88,343,372.15,341.25,371.61,341.08Zm-.78,19.27h-3.89V345.42h3.43c.57.46,2.07,2.14,2.07,7.17S371.33,359.61,370.83,360.35Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#aadff0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M365.63,336.68c0,1.06-5.36,1.92-12,1.92s-12-.86-12-1.92,5.36-1.93,12-1.93S365.63,335.61,365.63,336.68Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#aadff0"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M347.08,337.7s-1.74-.33-1.9,3.79,0,9.33,0,9.33",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M345.12,351l-1.45,1.93s-.2,3.62-.16,3.62l4.11.09.14-3.54Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#262262"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M356.8,320.63a26.17,26.17,0,0,1,2.72-3.25,16.37,16.37,0,0,0,2.65-16.48,15.86,15.86,0,0,1,4.26,7.26,9.71,9.71,0,0,1-1.52,8.1c-1.22,1.57-3,2.63-4.35,4-2.95,3-3.7,7-3.18,11C354.73,329.71,355.45,322.85,356.8,320.63Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M347.31,320.63a26.17,26.17,0,0,1,2.72-3.25,16.4,16.4,0,0,0,2.65-16.48,15.86,15.86,0,0,1,4.26,7.26,9.75,9.75,0,0,1-1.53,8.1c-1.21,1.57-3,2.63-4.34,4-2.95,3-3.71,7-3.18,11C345.23,329.71,346,322.85,347.31,320.63Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M352,335h0a138.4,138.4,0,0,1-1.16-30L352,288.52h0C345.57,301.25,347,318,352,335Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#c3e3fc"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M356.94,337.79h0a102.26,102.26,0,0,1-.55-17.84l.55-9.84h0C353.87,317.67,354.56,327.63,356.94,337.79Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#c3e3fc"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M353.32,332.93h0a101.25,101.25,0,0,1,.4-17.84l1.11-9.81h0C351.33,312.67,351.49,322.66,353.32,332.93Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#c3e3fc"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.82,354.64c-.61-2.83-1-5.93.28-8.51s5.06-4.06,7.22-2.12c1.07,1,1.47,2.46,2.23,3.69s2.35,2.26,3.6,1.53q0-12.15-.52-24.29c-.19-4.14-.35-8.59,1.89-12.07s7.94-5,10.49-1.7a9,9,0,0,1,1.48,4c2.83,15.57-2.23,31.54-9.2,45.74a12,12,0,0,1-2,3.17c-2.22,2.28-8.33,3.33-11.2,1.68S143.51,357.88,142.82,354.64Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#39b54a"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M165.06,309.45s8.32,32.76-12.25,56.27",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M162.9,309.45s4.77,37.31-12.94,56.27",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M148.57,365.72c-7-13-3.19-21.9-3.19-21.9a71.14,71.14,0,0,1,3.58,20.5",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M146.47,343.82s8.31,5.64,3.49,20.5",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M159.76,310.67s4.13,28.09-6.95,48.84",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M157.52,312.86s1.38,18.72,0,27.54",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "103.47 265.51 107.65 284.85 120.94 284.85 125.24 266.32 103.47 265.51",
    fill: "#ce791d"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M166,368.82H139.63a.58.58,0,0,1-.57-.57v-5.06a.58.58,0,0,1,.57-.57H166a.58.58,0,0,1,.57.57v5.06A.58.58,0,0,1,166,368.82Z",
    transform: "translate(-38.77 -100.21)",
    fill: "#f7941d"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.4 245.83 355.4 248.82 379.25 272.36 436.88 271.45 436.88 266.73 355.4 245.83",
    fill: "#aadff0"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "355.4 245.83 402.07 245.83 436.88 266.73 379.64 268.26 355.4 245.83",
    fill: "#f1f2f2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M396.43,347.41a1.88,1.88,0,0,0-1.43-2.54,2.66,2.66,0,0,0-2.69,1.66,4.54,4.54,0,0,0,.07,3.32c.42,1.15,1.36,2.31,2.59,2.26,1.48-.06,2.28-1.77,2.54-3.23.1-.56.11-1.25-.37-1.55-.7-.44-1.49.46-1.74,1.25a5.41,5.41,0,0,0,0,3.64,3.17,3.17,0,0,0,2.87,2,2.67,2.67,0,0,0,2.1-3.79.87.87,0,0,0-1.16,0,2.48,2.48,0,0,0-.69,1.07,7.79,7.79,0,0,0-.76,2.77,2.79,2.79,0,0,0,1.2,2.48,2.89,2.89,0,0,0,1.9.28,3.66,3.66,0,0,0,3.24-3.23,1.26,1.26,0,0,0-.7-1.28,1.35,1.35,0,0,0-1.29.51,4.12,4.12,0,0,0-1,4.34,3.49,3.49,0,0,0,3.8,2.11,3,3,0,0,0,2.25-3.56,2.65,2.65,0,0,0-2.69,1.6,4.37,4.37,0,0,0-.13,3.92,3.36,3.36,0,0,0,3.35,1.83,2.73,2.73,0,0,0,2.27-2.89,1.37,1.37,0,0,0-2.47-.73,3.69,3.69,0,0,0-.87,2.13c-.23,1.62-.06,3.49,1.18,4.58a3.09,3.09,0,0,0,5.09-2.79.86.86,0,0,0-.3-.61.88.88,0,0,0-.87.06,3.1,3.1,0,1,0,4.48,2.48,1.58,1.58,0,0,0-2.19.49,4.19,4.19,0,0,0-.52,2.45c0,1.26.22,2.7,1.26,3.43,1.46,1,3.68-.24,4.1-2a2.12,2.12,0,0,0-.1-1.47,1.14,1.14,0,0,0-1.25-.6,1.48,1.48,0,0,0-.72.61,4.75,4.75,0,0,0-.48,4.65",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#383838",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.57
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M463.34,363.42a2.32,2.32,0,0,0-2.44-.11,9.64,9.64,0,0,1-2.38,1,7,7,0,0,1-2.43-.32,21.47,21.47,0,0,0-4.67-.32c-2.84,0-5.67,0-8.51.13-1.68.06-3.36.14-5,.24l-3.26.23-9.57.69",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M460,360.73a5.6,5.6,0,0,0-2.39-.77,2,2,0,0,0-2,1.29,2.82,2.82,0,0,0-2.95-1.15c-.44.1-.85.32-1.3.43a6,6,0,0,1-2,0c-1.55-.14-3.1-.22-4.65-.23a19.89,19.89,0,0,0-5.11.5,5.3,5.3,0,0,1-2.66.3c-.35-.09-.67-.27-1-.38a5.51,5.51,0,0,0-2.49,0c-1.57.22-3.13.49-4.68.78",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M454.47,358.08l-3.78-.79a3.53,3.53,0,0,0-1.44-.1c-.38.09-.72.3-1.1.39-1.07.26-2.13-.48-3.23-.51a9,9,0,0,0-1.84.33,11.78,11.78,0,0,1-2.59.11l-3.61-.1a3.53,3.53,0,0,0-1.17.1c-.25.09-.48.23-.72.33a2.78,2.78,0,0,1-2.39-.1,1.13,1.13,0,0,0-.54-.21c-.32,0-.53.31-.74.55s-.57.44-.81.23",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M450.25,355.48c-2.74,0-5.48.1-8.22-.1a18.64,18.64,0,0,0-3.34-.07c-1.54.17-3,.81-4.52,1.06a9,9,0,0,1-3.5-.09,15.48,15.48,0,0,0-2.23-.46c-.93-.06-1.86.21-2.8.21a11.73,11.73,0,0,0-2.51,0c-.57.12-1.08.42-1.65.57-1.14.29-2.41-.07-3.51.36",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M446.23,352.71c-1.36.3-2.65-.77-4-.85s-2.46.69-3.72,1a17.37,17.37,0,0,1-3.68.14c-1.07,0-2.13.2-3.2.18-1.84,0-3.74-.58-5.47,0",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M443.3,350.44c-3.24.11-6.5-1.17-9.66-.5-1.3.28-2.51.88-3.81,1.19-3.19.77-6.55-.25-9.84-.06a18.87,18.87,0,0,1-3.6.15,3.88,3.88,0,0,0-1.94-.05c-.59.23-1.11.86-1.71.67-.44-.14-.83-.71-1.24-.49",
    transform: "translate(-38.77 -100.21)",
    fill: "none",
    stroke: "#bcbec0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.28
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 229,
    r: 10.9,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.8589763ed86e7990decf0f462ef4a434.svg";
export { ForwardRef as ReactComponent };